import { api, ApiError } from "@/api/api";
import { AssignUserToEpisodesRequestData } from "@/api/validation-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useAssignUserToEpisodes() {
  const queryClient = useQueryClient();

  return useMutation<{}, ApiError, AssignUserToEpisodesRequestData>({
    mutationKey: ["POST", "validation", "assignUserToEpisodes"],
    mutationFn: api.validation.assignUserToEpisodes.post,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["GET", "episodes"] });
      for (const episodeId of variables.episodeIds) {
        queryClient.invalidateQueries({
          queryKey: ["GET", "episodeDetails", episodeId],
        });
      }
      // TODO: invalidate only affected images and masks (need to know images and masks ids here, now only episodes ids are given)
      queryClient.invalidateQueries({ queryKey: ["GET", "images"] });
      queryClient.invalidateQueries({ queryKey: ["GET", "masks"] });
      queryClient.invalidateQueries({
        queryKey: ["GET", "submission", "assetsReadyForSubmission"],
      });
    },
  });
}
